export const FORUM_TYPE = {
  COMMUNITY: 0,
  KNOWLEDGE_BASE: 1,
  IDEATION: 2,
  NEWS: 3,
  PUBLIC_GROUP: 4,
  PRIVATE_GROUP: 5,
  HIDDEN_GROUP: 6
}

export interface Category {
  categoryId: number
  categoryName: string
}

export interface Group {
  groupId: number
  groupName: string
  type: typeof FORUM_TYPE.PUBLIC_GROUP | typeof FORUM_TYPE.PRIVATE_GROUP | typeof FORUM_TYPE.HIDDEN_GROUP
}

export interface ParentCategory {
  groupId: number
  groupName: string
  type: typeof FORUM_TYPE.COMMUNITY | typeof FORUM_TYPE.KNOWLEDGE_BASE
  categories?: Category[]
}

export interface ParentCategoryWithCategories extends Exclude<ParentCategory, 'categories'>{
  categories: Category[]
}

export interface Categories extends Array<ParentCategory | Group>{}
